import { ReactNode } from "react";
import cn from "classnames";

import { Panel as CommonPanel, PanelProps as CommonPanelProps } from "capitalrx-components-2.0/lib/general";

import styles from "./styles.module.scss";

export interface PanelProps extends CommonPanelProps {
  children: ReactNode;
  noPadding?: boolean;
}

export const Panel = (props: PanelProps) => {
  const { children, className, noPadding } = props;
  const panelClass = cn(styles["Panel"], { NoPadding: noPadding }, className);

  return (
    <CommonPanel {...props} className={panelClass}>
      {children}
    </CommonPanel>
  );
};
